export interface ICreateCarrierInputDto {
    organizationId?: string;
    name: string;
    code: string;
    externalId?: string;
    businessName: string;
    address?: string;
    vatNumber?: string;
    country?: string;
    influenceZone?: string;
    locations?: string[];
    tags?: string[];
    phoneNumber?: string;
    email?: string;
}
